var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 15.214,
    viewBox: "0 0 24 15.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18579",
    "data-name": "Group 18579",
    transform: "translate(12967.5 -9722.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "push_pin_FILL1_wght500_GRAD0_opsz24",
    d: "M238.622-846.389l1.3,1.483v1.692h-3.287v4.432l-.738.844-.738-.844v-4.432h-3.287v-1.692l1.3-1.483v-5.076h-.649v-1.687h6.753v1.687h-.649Z",
    transform: "translate(-13191.395 10575.427)",
    fill: "#b9c1cb"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4670",
    "data-name": "Line 4670",
    x2: 24,
    transform: "translate(-12967.5 9728.167)",
    fill: "none",
    stroke: "#b9c1cb",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPin);
export default __webpack_public_path__ + "static/media/no-pin.67c22a963174ae10659cb96b5b98fd71.svg";
export { ForwardRef as ReactComponent };